export const INFO_SENT_PLAN_PROGRESS = [
  { value: null, name: '（全て表示）' },
  { value: 2, name: '2.説明・同意待ち' },
  { value: 3, name: '3.依頼済・同意待ち' },
  { value: 6, name: '4.同意・交付済' },
  { value: 1, name: '9.事前同意' },
];
